var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "white",
    stroke: "#EC0000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4191 17.3252C34.712 17.0323 34.712 16.5574 34.4191 16.2645C34.1262 15.9716 33.6513 15.9716 33.3584 16.2645L25.6836 23.9393L18.0088 16.2645C17.716 15.9716 17.2411 15.9716 16.9482 16.2645C16.6553 16.5574 16.6553 17.0323 16.9482 17.3252L24.623 25L16.9482 32.6748C16.6553 32.9677 16.6553 33.4426 16.9482 33.7354C17.2411 34.0283 17.716 34.0283 18.0088 33.7355L25.6836 26.0606L33.3584 33.7354C33.6513 34.0283 34.1262 34.0283 34.4191 33.7354C34.712 33.4426 34.712 32.9677 34.4191 32.6748L26.7443 25L34.4191 17.3252Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNoRed);
export default __webpack_public_path__ + "static/media/ico_no_red.a8de155b4f1681b08155ca497eda6873.svg";
export { ForwardRef as ReactComponent };